/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { Suspense } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import Facts from 'components/Facts'
import { Related } from 'components/Related'
import { Link } from '@ta-interaktiv/contentbricks'

import { StandaloneIFrame } from 'components/StandaloneIFrame'
// TODO S et the correct article ID here
const ARTICLE_ID = '208920009412'

const _Tests = React.lazy(() => import('components/Tests'))
const _Geografic = React.lazy(() => import('components/Geografic'))
const _Ages = React.lazy(() => import('components/Ages'))
const _VaccStatus = React.lazy(() => import('components/VaccStatus'))
const _Hospitalisation = React.lazy(() => import('components/Hospitalisation'))
const _Hospitals = React.lazy(() => import('components/Hospitals'))
const _WasteWater = React.lazy(() => import('components/WasteWater'))

const Loader = () => {
  return (
    <div className='ui vertical segment'>
      <div className='ui text container'>...</div>
    </div>
  )
}

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Die neusten Zürcher Zahlen zur Corona-Pandemie</h1>
            <h2>Kennzahlen der Epidemie im Kanton Zürich</h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='info'>
            Die Gesundheitsdirektion des Kantons Zürich hat sich entschieden,
            die Fallzahlen <b>nach dem 3.1.2023 nicht mehr zu aktualisieren</b>.
            In dieser Übersicht werden nur noch die Grafiken «Nachweise im
            Abwasser» und «Medizinische Versorgung» aktualisiert.
          </div>
          <div className='ta metainfo'>
            <div className='ta author'>Interaktiv Team</div>
            {/* <div className='ta updated'>Wird dienstags aktualisiert</div> */}
          </div>
        </div>
        {/* <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Facts />{' '}
          </div>
        </div>{' '} */}
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='segmenttitle'>
            Vergleich mit Ländern und Kontinenten
          </div>{' '}
          <div className='segmentlead'>
            In dieser täglich aktualisierten interaktiven Grafik können Sie
            beliebige Länder oder die Schweizer Kantone miteinander vergleichen.
            Ob Sie dabei Todesfälle und Infektionen absolut, relativ, kumuliert
            oder als neue Fälle anzeigen wollen, ist Ihnen überlassen. Die Daten
            für die Schweiz und die Kantone werden am Wochenende nicht
            aktualisiert.{' '}
          </div>
        </div>
        <div className='ui container'>
          <StandaloneIFrame
            url='https://interaktiv.tagesanzeiger.ch/2020/covid-laendervergleich-embed/embed.html?int=true&fixed=CH%20-%20ZH&embedId=ZHDash'
            id='Vergleich'
            initialHeight={1050}
          />
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='segmenttitle'>Nachweise im Abwasser</div>
        </div>

        <Suspense fallback={<Loader />}>
          <_WasteWater />
        </Suspense>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='segmenttitle'>Medizinische Versorgung</div>
          <Suspense fallback={<Loader />}>
            <_Hospitalisation />
          </Suspense>{' '}
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <Suspense fallback={<Loader />}>
            <_Hospitals />
          </Suspense>
        </div>
      </div>

      {/*
      <div className='ui vertical segment'>
        <Suspense fallback={<Loader />}>
          <_VaccStatus />
        </Suspense>
      </div>
      */}

      <div className='ui vertical segment'>
        <Suspense fallback={<Loader />}>
          <_Geografic />
        </Suspense>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='segmenttitle'>Testmenge und Positivitätsrate</div>
        </div>
        <div className='ui  container'>
          <Suspense fallback={<Loader />}>
            <_Tests />
          </Suspense>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='segmenttitle'>Unterschiede in den Altersgruppen</div>
        </div>

        <Suspense fallback={<Loader />}>
          <_Ages />
        </Suspense>
      </div>

      <div style={{ clear: 'both' }} />
      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Konzept und Umsetzung', 'Mark Brupbacher, Sebastian Broschinski']
        ]}
      />
    </div>
  )
}
